import Modal, { ModalWrapper } from './Modal';
import { useAgreeTerms, useFetchUserAbout } from 'utils/hooks';
import { Button } from './Button';
import Stack from './Stack';
import styled from 'styled-components';
import { withMixpanel } from 'utils/app';

const AgreeModal = styled(ModalWrapper)`
    width: 90vw;
    max-width: 30rem;
`;

const AgreeSection = styled.div`
    color: ${({ theme }) => theme.gray_7};
    font-size: 0.8rem;
    padding: 1rem;
    margin: 0 auto;
    max-width: 21rem;
    display: grid;
    grid-template-columns: min-content 1fr;
    gap: 1em;
    align-items: start;
    background-color: rgba(255, 255, 255, 0.1);
    border-radius: ${({ theme }) => theme.borderRadius_lg};

    & input[type='checkbox'] {
        accent-color: rgb(152, 100, 255) !important;
        cursor: pointer !important;
        width: 1rem !important;
        height: 1rem !important;
        appearance: auto !important;
        -webkit-appearance: checkbox !important;
        -moz-appearance: checkbox !important;
    }
`;

const FormColumn = styled.div`
    display: flex;
    flex-direction: column;
`;

const SubmitFooter = styled.div`
    display: flex;
    justify-content: center;
    padding-top: 1rem;
`;

function PrivacyPolicyLink({ children = 'privacy policy' }) {
    return (
        <a
            href="https://www.spate.nyc/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
        >
            {children}
        </a>
    );
}

function TermsLink({ children = 'terms and conditions' }) {
    return (
        <a
            href="https://www.spate.nyc/terms-of-service"
            target="_blank"
            rel="noopener noreferrer"
        >
            {children}
        </a>
    );
}

export const useUserAgreements = (mixpanel) => {
    const aboutQuery = useFetchUserAbout();
    const agreeTermsMutation = useAgreeTerms();
    const agreeTerms = agreeTermsMutation.mutate;
    const aboutQueryIsSettled =
        aboutQuery.status === 'success' ||
        (aboutQuery.status === 'error' && !aboutQuery.isFetching);
    const agreements =
        aboutQuery.data && aboutQuery.data.agreements
            ? aboutQuery.data.agreements
            : [];

    // no difference at this time between falsey and false for these agreements
    const agreed_terms = agreements.some(
        ({ name, agreed }) => name === 'terms' && agreed,
    );
    const agreed_tracking = agreements.some(
        ({ name, agreed }) => name === 'tracking' && agreed,
    );

    const open = aboutQueryIsSettled && !agreed_terms;

    const onClose = () => {};

    const onSubmit = (e) => {
        e.preventDefault();
        if (!agreed_terms) {
            agreeTerms();
        }
    };

    return {
        agreed_terms,
        agreed_tracking,
        open,
        onClose,
        onSubmit,
    };
};

const AgreeTermsAndTracking = withMixpanel(({ mixpanel }) => {
    const { agreed_terms, open, onClose, onSubmit } =
        useUserAgreements(mixpanel);

    return (
        <Modal open={open} onClose={onClose} ModalComponent={AgreeModal}>
            <Stack
                as="form"
                $space="1em"
                onSubmit={onSubmit}
                css="margin: 1em;"
            >
                {!agreed_terms ? (
                    <h2 css="text-align: center;">Agree to Terms</h2>
                ) : null}
                {!agreed_terms ? (
                    <FormColumn>
                        <p>
                            Please agree to the Spate Terms and Conditions and
                            Privacy Policy
                        </p>
                        <AgreeSection as="label">
                            <input type="checkbox" required />
                            <span>
                                I accept the Spate <TermsLink /> and{' '}
                                <PrivacyPolicyLink />
                            </span>
                        </AgreeSection>
                    </FormColumn>
                ) : null}
                <SubmitFooter>
                    <Button type="submit">Agree</Button>
                </SubmitFooter>
            </Stack>
        </Modal>
    );
});

export default AgreeTermsAndTracking;
